import { type TranslationsData } from '@/types/translations'
import env from '@/config/env'
import { createAxiosInstance } from '@/api/http'

const http = createAxiosInstance({
  baseURL: env.frasierApiBaseUrl
})

const getTranslations = async (language: string): Promise<TranslationsData> => {
  const url = `translations/${env.frasierDomain}/locales/${language}`

  const { data } = await http.get(url)
  return data
}

export default { getTranslations }
